import { Col, Modal, Row } from 'antd';
import React, { useState } from 'react';
import { useMedia } from 'react-use';
import { BREAKPOINTS } from '../../../../common/constants';
import CommonCard from '../../../../components/CommonCard';
import StageItemList from './stageItemList/StageItemList';
import StageList from './stageList/StageList';

const EqcDetailContent = ({ eqcTypeData }) => {
  const [stageId, setStageId] = useState();
  const [stageData, setStageData] = useState();
  const [title, setTitle] = useState();
  const [modalVisible, setModalVisible] = useState(false);
  const [refetchStageData, setRefetchStageData] = useState(null);
  const [isStageSelectionActive, setIsStageSelectionActive] = useState(false);
  const [isStageItemSelectionActive, setIsStageItemSelectionActive] =
    useState(false);
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);

  return (
    <div id="eqc-detail-content" className="mb-20">
      <Row gutter={[16, 16]}>
        <Col span={isDesktopViewport ? 8 : 24}>
          <StageList
            setStageId={setStageId}
            stageId={stageId}
            setModalVisible={setModalVisible}
            eqcTypeData={eqcTypeData}
            setTitle={setTitle}
            setStageData={setStageData}
            setRefetchStageData={setRefetchStageData}
            setIsStageSelectionActive={setIsStageSelectionActive}
            isStageItemSelectionActive={isStageItemSelectionActive}
          />
        </Col>
        {isDesktopViewport ? (
          <Col span={16}>
            {stageId ? (
              <StageItemList
                stageId={stageId}
                stageData={stageData}
                eqcTypeData={eqcTypeData}
                refetchStageData={refetchStageData}
                isStageSelectionActive={isStageSelectionActive}
                setIsStageItemSelectionActive={setIsStageItemSelectionActive}
              />
            ) : (
              <CommonCard id="empty-stage-card" className="stage-item-card">
                <div
                  id="empty-stage-header"
                  className="header d-flex align-center justify-center"
                >
                  <h2 id="empty-stage-message" className="mb-0">
                    Please Select Stage First
                  </h2>
                </div>
              </CommonCard>
            )}
          </Col>
        ) : (
          <>
            <div id="stage-item-modal" />
            <Modal
              id="stage-item-modal-dialog"
              maskClosable={false}
              // eslint-disable-next-line no-undef
              getContainer={() => document.getElementById('stage-item-modal')}
              width="100vw"
              title={title}
              open={modalVisible}
              footer={null}
              destroyOnHidden
              onCancel={() => setModalVisible(false)}
            >
              <StageItemList
                stageId={stageId}
                stageData={stageData}
                eqcTypeData={eqcTypeData}
                refetchStageData={refetchStageData}
                isStageSelectionActive={isStageSelectionActive}
                setIsStageItemSelectionActive={setIsStageItemSelectionActive}
              />
            </Modal>
          </>
        )}
      </Row>
    </div>
  );
};

export default EqcDetailContent;
